<!--
 * @Author: cryi.liu
 * @Date: 2020-05-28 16:27:55
 * @LastEditTime: 2020-06-02 14:54:08
 * @Description: 试题总数
-->
<template>
  <div class="question-total">
    <p class="title">
      <span>考试时长：{{ examTime }}</span>
      <span>总分：{{ totalScore }}</span>
      <span>通过分数：{{ passScore }}</span>
    </p>
    <i-table :columns="columns" :data="data" border />
  </div>
</template>

<script>
export default {
  name: 'QuestionTotal',
  props: {
    examTime: { type: [Number, String], required: true, default: '未设置' },
    totalScore: { type: [Number, String], required: true, default: 0 },
    passScore: { type: [Number, String], required: true, default: '未设置' },
    data: { type: Array, required: true },
  },
  data() {
    return {
      columns: [
        {
          title: '大类',
          align: 'center',
          key: 'questionType',
        },
        {
          title: '题目数',
          align: 'center',
          key: 'libraryCount',
        },
        {
          title: '题型总分',
          align: 'center',
          key: 'totalScore',
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.question-total {
  width: 100%;

  > .title {
    font-size: 13px;
    margin-bottom: 12px;

    > span {
      margin-right: 12px;

      &:last-of-type {
        margin-right: 0;
      }
    }
  }
}
</style>
